'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _mockData = require('./mockData');

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogMock = exports.CatalogMock = {
    fetchCatalogItems: function fetchCatalogItems(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = catalogIds.reduce(function (previous, id) {
                    return (0, _union2.default)(previous, (0, _mockData.getTestItemsForCatalog)(id));
                }, []);
                resolve({
                    data: items
                });
            }, _delay2.default);
        });
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var catalogs = catalogIds.map(function (x) {
                    return (0, _mockData.getTestCatalog)(x);
                });
                var bidIncrements = [];
                var sellers = [];

                catalogs.forEach(function (item) {
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/catalog.js
// module id = eyX+
// module chunks = 46